import { render } from "./PlayActivity.vue?vue&type=template&id=a0a8f422&scoped=true"
import script from "./PlayActivity.vue?vue&type=script&lang=js"
export * from "./PlayActivity.vue?vue&type=script&lang=js"

import "./PlayActivity.vue?vue&type=style&index=0&id=a0a8f422&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a8f422"]])

export default __exports__